export default __webpack_public_path__ + "static/Play-Bold-543d6025dd5c63651d22c72144f60f69.ttf";